import React from 'react';
import './navbar.scss';
import { motion } from 'framer-motion';
import Sidebar from '../sidebar/Sidebar';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <div className="navbar">
      {/* Sidebar Component */}
      <Sidebar />

      <div className="wrapper">
        {/* Logo */}
        <motion.div
          className="logo"
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
       <Link to="/" >   <img src="/arrowdigital.png" alt="Company Logo" /></Link>
        </motion.div>

        {/* Social Icons */}
        <motion.div
          className="social"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <a href="https://www.instagram.com/arrowdigital_com/" target="_blank" rel="noopener noreferrer">
            <img src="/instagram.png" alt="Instagram" />
          </a>
          <a href="https://www.facebook.com/ArrowDigitalAU" target="_blank" rel="noopener noreferrer">
            <img src="/facebook.png" alt="Facebook" />
          </a>
          <a href="https://www.youtube.com/@Arrow.digital.marketing" target="_blank" rel="noopener noreferrer">
            <img src="/youtube.png" alt="YouTube" />
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default Navbar;
